import React from 'react'
import {dateFormat} from '../../../modules/Utils'
import moment from 'moment'

const DateCell = ({value}) => value && dateFormat(moment(value))
export default DateCell
